import { gsap } from "gsap";
import inviewAnim from "./modules/inview";
import menu from "./modules/menu";
import pickUpSlider from "./modules/pick-up-slider";
import topNewsSlider from "./modules/top-news-slider";
import bgParallax from "./modules/bg-parallax";
import topScrollEvent from "./modules/top-scroll-event";
import foodTab from "./modules/food-tab";
import { setModal } from "./modules/libs";


window.addEventListener("load", () => {
  menu();
  pickUpSlider();
  topNewsSlider();
  topScrollEvent();
  foodTab();
  setModal();
  bgParallax();
  inviewAnim();
});